import {
  enterLong,
  enterShort,
} from '../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/enterNow';
import { flattenTradePlan } from '../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/flattenTradePlan';
import { pauseTradePlan } from '../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/pauseTradePlan';
import { removeTradePlan } from '../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/removeTradePlan';

// Central command registry. Buttons and hotkeys (and future external
// integrations) invoke identical commands by name; commands resolve the
// selected trade plan from the store, so callers never need a tradePlanId.
//
// Guards mirror the availability of the equivalent buttons in the Active
// Trade Plans view: a command that would correspond to a hidden or disabled
// button does not execute.

const isDeactivatedAwaitingRestart = (tradePlan) =>
  Boolean(
    tradePlan.restartSystemOncePositionHasFlattened &&
      tradePlan.restartSettings?.deactivated
  );

const commands = {
  enterLong: {
    isAllowed: (tradePlan) =>
      !tradePlan.inPosition && Boolean(tradePlan.goLong),
    run: (tradePlan) => enterLong(tradePlan.id),
  },
  enterShort: {
    isAllowed: (tradePlan) =>
      !tradePlan.inPosition && Boolean(tradePlan.goShort),
    run: (tradePlan) => enterShort(tradePlan.id),
  },
  flatten: {
    isAllowed: (tradePlan) => Boolean(tradePlan.inPosition),
    run: (tradePlan) => flattenTradePlan(tradePlan.id),
  },
  pause: {
    isAllowed: (tradePlan) =>
      !tradePlan.inPosition &&
      !tradePlan.paused &&
      !isDeactivatedAwaitingRestart(tradePlan),
    run: (tradePlan) => pauseTradePlan(tradePlan.id, true),
  },
  resume: {
    isAllowed: (tradePlan) =>
      !tradePlan.inPosition &&
      Boolean(tradePlan.paused) &&
      !isDeactivatedAwaitingRestart(tradePlan),
    run: (tradePlan) => pauseTradePlan(tradePlan.id, false),
  },
  cancel: {
    isAllowed: (tradePlan) => !tradePlan.inPosition,
    run: (tradePlan) => removeTradePlan(tradePlan.id),
  },
};

let websocketStore = null;

export function initializeCommandRegistry(store) {
  websocketStore = store;
}

export const CommandRegistry = {
  // Executes a command against the currently selected trade plan.
  // Returns true when the command was dispatched, false when blocked.
  execute(commandName) {
    const command = commands[commandName];
    if (!command) return false;
    if (!websocketStore) return false;

    const tradePlan =
      websocketStore.tradePlanSelectionStore.selectedTradePlan;
    if (!tradePlan || tradePlan.__pending === true) return false;
    if (!command.isAllowed(tradePlan)) return false;

    command.run(tradePlan);
    return true;
  },

  isCommand(commandName) {
    return Boolean(commands[commandName]);
  },
};
